import React, { useEffect, useState, useRef } from "react";
import { ButtonBase, DataTableBase, ModalBase } from "@reusejs/react";
import { useRouter } from "next/router";
import {
  getAuctionEventById,
  getBidderForEvent,
  addBidderForEvent,
  deleteBidderForEvent,
  updateBidderForEvent,
  getTeamMembers,
} from "services";
import AddBidderModal from "./addBidder";
import { XIcon, PencilIcon, EyeIcon } from "@heroicons/react/solid";
import ConfirmationModal from "./confirmationModal";
import { useSelector } from "react-redux";
import { DateTime } from "luxon";

export default function ViewBidders() {
  const router = useRouter();
  const { for_event } = router.query;
  const [event, setEvent] = useState<any>([]);
  const [membersEmail, setMembersEmail] = useState<any>([]);

  const banker = useSelector((state: any) => {
    return state.bankerAuth.user;
  });

  const currentBranch = useSelector((state: any) => {
    return state.bankerAuth.currentBranch;
  });

  const bank = useSelector((state: any) => {
    return state.bankerAuth.bank;
  });

  const tableRef = useRef<any>(null);
  const [config, setConfig] = useState<any>({
    filterable: false,
    columns: [
      {
        label: "Email",
        identifier: "email",
        resolver: (d: any) => {
          return d.email;
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "KYC Verified",
        identifier: "kyc_verified",
        resolver: (d: any) => {
          return d.kyc_verified ? "Yes" : "No";
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "Emd Amount Paid",
        identifier: "emd_amount_paid",
        resolver: (d: any) => {
          return d.emd_amount_paid ? "Yes" : "No";
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "Agreement Signed",
        identifier: "agreement_signed",
        resolver: (d: any) => {
          return d.agreement_signed ? "Yes" : "No";
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "Application Form Filled",
        identifier: "application_form_filled",
        resolver: (d: any) => {
          return d.application_form_filled ? "Yes" : "No";
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "Status",
        identifier: "status",
        resolver: (d: any) => {
          return d.status;
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "",
        filterable: {
          type: "clear",
        },
        actions: true,
        resolver: (d: any) => {
          return (
            <div className="flex justify-center items-center space-x-2">
              <div>
                <EyeIcon
                  className="flex-shrink-0 h-4 w-4 text-green-500 hover:text-green-700 cursor-pointer"
                  aria-hidden="true"
                  onClick={() =>
                    router.push(
                      `/dashboard/bidders/${d.uuid}?for_event=${for_event}`
                    )
                  }
                />
              </div>
              <div>
                {d.created_by === "banker" && (
                  <PencilIcon
                    className="flex-shrink-0 h-4 w-4 text-yellow-500 hover:text-yellow-700 cursor-pointer"
                    aria-hidden="true"
                    onClick={() =>
                      openModal(
                        "Update Bidder",
                        "",
                        "bg-blue-50 text-blue-500",
                        "edit",
                        d
                      )
                    }
                  />
                )}
              </div>
              <div>
                <XIcon
                  className="flex-shrink-0 h-4 w-4 text-red-400 hover:text-red-600 cursor-pointer"
                  aria-hidden="true"
                  onClick={() =>
                    openDeletionConfirmationModal(
                      "Delete Bidder",
                      "Are you sure you want to remove bidder?",
                      "bg-red-50 text-red-500",
                      d.uuid
                    )
                  }
                />
              </div>
            </div>
          );
        },
      },
    ],
  });
  const [configE, setConfigE] = useState<any>({
    filterable: false,
    columns: [
      {
        label: "Email",
        identifier: "email",
        resolver: (d: any) => {
          return d.email;
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "KYC Verified",
        identifier: "kyc_verified",
        resolver: (d: any) => {
          return d.kyc_verified ? "Yes" : "No";
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "Emd Amount Paid",
        identifier: "emd_amount_paid",
        resolver: (d: any) => {
          return d.emd_amount_paid ? "Yes" : "No";
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "Agreement Signed",
        identifier: "agreement_signed",
        resolver: (d: any) => {
          return d.agreement_signed ? "Yes" : "No";
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "Application Form Filled",
        identifier: "application_form_filled",
        resolver: (d: any) => {
          return d.application_form_filled ? "Yes" : "No";
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "Status",
        identifier: "status",
        resolver: (d: any) => {
          return d.status;
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "",
        filterable: {
          type: "clear",
        },
        actions: true,
        resolver: (d: any) => {
          return (
            <div className="flex justify-center items-center space-x-2">
              <div>
                <ButtonBase
                  variant="primary"
                  type="button"
                  label="View"
                  onClick={() =>
                    router.push(
                      `/dashboard/bidders/${d.uuid}?for_event=${for_event}`
                    )
                  }
                  buttonBaseClasses={{
                    font: "text-sm font-medium",
                    backgroundColor: "bg-blue-600 hover:bg-blue-700",
                    textColor: "text-white",
                    border: "any",
                    padding: "px-2 py-2",
                  }}
                />
              </div>
            </div>
          );
        },
      },
    ],
  });

  const getTeamMembersEmail = async () => {
    let response: any = await getTeamMembers(currentBranch?.team["teams*uuid"]);
    const filteredData = response.data.map(
      (item: any) => item?.attributes[0]?.value
    );
    setMembersEmail(filteredData);
  };

  useEffect(() => {
    if (for_event) {
      (async () => {
        await init(for_event);
      })();
    }
    getTeamMembersEmail();
  }, [for_event]);

  const init = async (id: any) => {
    const data: any = await getAuctionEventById(id);
    setEvent(data);
  };

  useEffect(() => {
    if (tableRef && tableRef.current) {
      tableRef?.current?.refresh();
    }
  }, [event]);

  const dataSource = async (params: any) => {
    let response: any = {};

    if (event?.uuid) {
      response = await getBidderForEvent(params, event?.uuid);
    } else {
      response = { data: [], meta: { total: 0 } };
    }

    let data = response.data;

    return {
      data: data,
      pagination: {
        total: response.meta.total,
      },
    };
  };

  const openModal = async (
    title: string,
    message: string,
    color: string,
    type: string,
    data: any
  ) => {
    const AddModalWrapper = (props: any) => {
      return (
        <AddBidderModal
          router={router}
          heading={title}
          type={type}
          description={message}
          prefillData={data}
          excludeEmails={membersEmail}
          callback={async (form: any, formValue: any) =>
            type === "create"
              ? await handleAddBidder(form, formValue)
              : await hanldeUpdateBidder(form, formValue, data)
          }
          color={color}
          {...props}
        />
      );
    };

    await ModalBase(
      {
        content: AddModalWrapper,
        timeout: 0,
        backgroundColor: "bg-black/30",
        backgroundOpacity: "opacity-70",
        modalBaseClasses: {
          background: "bg-white",
          border: "border-2 rounded-lg",
          alignment: "text-left overflow-visible",
          padding: "p-0",
          small: "sm:my-8 sm:w-full sm:max-w-md",
        },
      },
      1000,
      "__next"
    );
  };

  const handleAddBidder = async (form: any, data: any) => {
    try {
      let payload = data;
      payload["event_uuid"] = event?.uuid;

      if (payload.initial_bid_price) {
        payload["initial_bid_price"] = Number(payload.initial_bid_price);
      }

      if (
        payload.kyc_verified &&
        payload.emd_amount_paid &&
        payload.agreement_signed &&
        payload.application_form_filled
      ) {
        payload["status"] = "verified";
      } else {
        payload["status"] = "pending";
      }

      const eventData: any = await getAuctionEventById(for_event);

      payload["meta"] = {
        banker_email: banker?.attributes[0]?.value,
        bank_name: bank?.name,
        approver_email:
          eventData?.meta?.approver && eventData?.meta?.approver.length > 0
            ? eventData?.meta?.approver[0]?.email
            : "",
        approver_name:
          eventData?.meta?.approver && eventData?.meta?.approver.length > 0
            ? eventData?.meta?.approver[0]?.name
              ? eventData?.meta?.approver[0]?.name
              : eventData?.meta?.approver[0]?.email
            : "",
        branch_name: currentBranch?.label,
        event_name: eventData?.event_name,
        dashboard_url: `${process.env.NEXT_PUBLIC_BIDDER_DB_URL}/auction-events`,
        event_id: eventData.listing_id,
        auction_start_datetime: DateTime.fromISO(eventData?.start_date_time)
          .setZone("Asia/Kolkata")
          .toFormat("dd MMMM yyyy hh:mm a"),
        emd_last_datetime: DateTime.fromISO(
          eventData?.property_dump?.emd_last_date
        )
          .setZone("Asia/Kolkata")
          .toFormat("dd MMMM yyyy hh:mm a"),
        name: payload.name,
        pan: payload.pan,
        ...(payload.initial_bid_price && payload.initial_bid_price > 0
          ? { initial_bid_price: payload.initial_bid_price }
          : {}),
      };

      const res = await addBidderForEvent(payload);
      if (res) {
        if (tableRef && tableRef.current) {
          tableRef?.current?.refresh();
        }
      }
      return true;
    } catch (error: any) {
      console.log("error", error);
      if (error?.response?.data?.errors) {
        form.setErrors(error.response.data.errors);
      }
      return false;
    }
  };

  const hanldeUpdateBidder = async (form: any, payload: any, data: any) => {
    try {
      payload["uuid"] = data.uuid;
      if (
        payload.kyc_verified &&
        payload.emd_amount_paid &&
        payload.agreement_signed &&
        payload.application_form_filled
      ) {
        payload["status"] = "verified";
      } else {
        payload["status"] = "pending";
      }

      const eventData: any = await getAuctionEventById(for_event);
      console.log("event::1234::>", eventData, for_event);
      payload["meta"] = {
        banker_email: banker?.attributes[0]?.value,
        bank_name: bank?.name,
        approver_email:
          eventData?.meta?.approver && eventData?.meta?.approver.length > 0
            ? eventData?.meta?.approver[0]?.email
            : "",
        approver_name:
          eventData?.meta?.approver && eventData?.meta?.approver.length > 0
            ? eventData?.meta?.approver[0]?.name
              ? eventData?.meta?.approver[0]?.name
              : eventData?.meta?.approver[0]?.email
            : "",
        branch_name: currentBranch?.label,
        event_name: eventData?.event_name,
        dashboard_url: `${process.env.NEXT_PUBLIC_BIDDER_DB_URL}/auction-events`,
        event_id: eventData.listing_id,
        auction_start_datetime: DateTime.fromISO(eventData?.start_date_time)
          .setZone("Asia/Kolkata")
          .toFormat("dd MMMM yyyy hh:mm a"),
        emd_last_datetime: DateTime.fromISO(
          eventData?.property_dump?.emd_last_date
        )
          .setZone("Asia/Kolkata")
          .toFormat("dd MMMM yyyy hh:mm a"),
        name: payload.name,
        pan: payload.pan,
      };
      const res = await updateBidderForEvent(payload);
      if (res) {
        if (tableRef && tableRef.current) {
          tableRef?.current?.refresh();
        }
      }
      return true;
    } catch (error: any) {
      console.log("error::", error);
      if (error?.response?.data?.errors) {
        form.setErrors(error.response.data.errors);
      }
      return false;
    }
  };

  const handleDeleteBidder = async (uuid: string) => {
    try {
      const res = await deleteBidderForEvent(uuid);
      if (res) {
        if (tableRef && tableRef.current) {
          tableRef?.current?.refresh();
        }
      }
    } catch (error) {
      console.log("check here error", error);
    }
  };

  const openDeletionConfirmationModal = async (
    title: string,
    message: string,
    color: string,
    uuid: string
  ) => {
    const ConfirmationModalWrapper = (props: any) => {
      return (
        <ConfirmationModal
          heading={title}
          description={message}
          callback={() => handleDeleteBidder(uuid)}
          color={color}
          {...props}
        />
      );
    };

    await ModalBase(
      {
        content: ConfirmationModalWrapper,
        timeout: 0,
        backgroundColor: "bg-black/30",
        backgroundOpacity: "opacity-70",
        modalBaseClasses: {
          background: "bg-white",
          border: "border-2 rounded-lg",
          alignment: "text-left overflow-visible",
          padding: "p-0",
          small: "sm:my-8 sm:w-full sm:max-w-md",
        },
      },
      1000,
      "__next"
    );
  };

  return (
    <div className="w-full p-6 flex flex-col justify-center">
      <div className="min-w-full flex justify-between">
        <div className="w-1/2 text-4xl text-blue-600 font-extrabold dark:text-red-600">
          Bidders
        </div>
        <div className="w-1/2 flex justify-end">
          <ButtonBase
            variant="primary"
            type="button"
            label="Add Bidder"
            onClick={() =>
              openModal(
                "Add Bidder",
                "",
                "bg-blue-50 text-blue-500",
                "create",
                null
              )
            }
            buttonBaseClasses={{
              font: "text-sm font-medium",
              backgroundColor: "bg-blue-600 hover:bg-blue-700",
              textColor: "text-white",
              border: "any",
              padding: "px-4 py-3",
            }}
            disabled={
              event && (event.status === "end" || event.status === "live")
            }
          />
        </div>
      </div>
      <div className="mt-10">
        <DataTableBase
          ref={tableRef}
          sortColumn={0}
          sortOrder={"asc"}
          dataSource={dataSource}
          perPage={10}
          config={
            event?.status === "end" || event?.status === "live"
              ? configE
              : config
          }
        />
      </div>
    </div>
  );
}
